module.exports = __webpack_public_path__ + "static/media/72.8033f058.png";